import { render, staticRenderFns } from "./contact-banner.vue?vue&type=template&id=742c8a18&scoped=true&"
import script from "./contact-banner.vue?vue&type=script&lang=js&"
export * from "./contact-banner.vue?vue&type=script&lang=js&"
import style0 from "./contact-banner.vue?vue&type=style&index=0&id=742c8a18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c8a18",
  null
  
)

export default component.exports